import React, { useEffect, useState } from "react";
import axios from "axios";

export default function AboutUs() {
  const [aboutContent, setAboutContent] = useState("");
  const [webFont, setWebFont] = useState("");
  const [themeColor, setThemeColor] = useState("");

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setWebFont(parsedStyle.web_font);
      setThemeColor(parsedStyle.web_theme_colour);
    }
  }, []);

  function lightenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) + 255 * percent;
    let g = ((num >> 8) & 0x00ff) + 255 * percent;
    let b = (num & 0x0000ff) + 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  function darkenHexColor(hex, percent) {
    const num = parseInt(hex.replace("#", ""), 16);
    let r = (num >> 16) - 255 * percent;
    let g = ((num >> 8) & 0x00ff) - 255 * percent;
    let b = (num & 0x0000ff) - 255 * percent;

    r = Math.max(0, Math.min(255, Math.round(r)));
    g = Math.max(0, Math.min(255, Math.round(g)));
    b = Math.max(0, Math.min(255, Math.round(b)));

    return `rgb(${r}, ${g}, ${b})`;
  }

  useEffect(() => {
    const fetchAbout = async () => {
      try {
        const formData = new FormData();
        formData.append("admin_auto_id", sessionStorage.getItem("admin_auto_id"));

        const response = await axios.post(
          `${process.env.REACT_APP_API_BASE_URL}/Show-About`,
          formData
        );

        if (response.data.status === 1 && response.data.allabouts.length > 0) {
          setAboutContent(response.data.allabouts[0].about);
        }
      } catch (error) {
        console.error("Error fetching About Us:", error);
      }
    };

    fetchAbout();
  }, []);

  return (
    <div className={`flex flex-col w-full px-4 sm:px-6 lg:px-8 ${webFont}`}>
      <h2 className="mb-4 text-xl font-bold text-center text-black">
        About Us
      </h2>

      {aboutContent && (
        <div className="w-full max-w-6xl p-4 mx-auto rounded-lg shadow-sm bg-gray-50 sm:p-6">
          {/*  IMPORTANT: preserve formatting from API */}
          <div className="text-sm leading-relaxed text-left text-gray-700 whitespace-pre-line sm:text-base">
            {aboutContent}
          </div>
        </div>
      )}
    </div>
  );
}
